<script>
export default {
  props: {
    xsmall: {
      type: Boolean,
      default: false,
    },
    xs: {
      type: Boolean,
      default: false,
    },
    iconType: {
      type: String,
      default: 'line',
      validator(value) {
        return ['line', 'picto', 'custom', 'etc', 'base', 'image', 'df'].indexOf(value) !== -1;
      },
    },
    iconColor:{ type: String, default: undefined },
  },
  computed: {
    buttonProps() {
      return {
        solid: this.solid,
        borderless: this.borderless,
        border: this.border,
        toggle: this.toggle,
        large: this.large,
        medium: this.medium,
        small: this.small,
        xsmall: this.xsmall,
        disabled: this.disabled,
        loading: this.loading,
        primary: this.primary,
        point: this.point,
        color: this.color,
        full: this.full,
        bor: this.bor,
        sol: this.sol,
        bLess: this.bLess,
        prim: this.prim,
        pnt: this.pnt,
        col: this.col,
        lg: this.lg,
        md: this.md,
        sm: this.sm,
        xs: this.xs,
      };
    },
    iconProps() {
      return {
        icon: this.icon,
        iconType: this.iconType !== 'mix' ? this.iconType : this.value ? 'picto' : 'line',
        iconSize: this.iconSize,
        color: this.iconColor,
        spacing: this.spacing,
        brand: this.brand,
        regular: this.regular,
        light: this.light,
        old: this.old,
        fab: this.fab,
        far: this.far,
        fal: this.fal,
        fa: this.fa,
        type: this.type,
        size: this.size,
      };
    },
  },
};
</script>
